export const URL_ONBOARDING = process.env.NEXT_PUBLIC_ONBOARDING_URL ?? "";
